import styled from 'styled-components';
import { ReactComponent as YabbleGenAvatarSvg } from 'assets/svg/yabble/yabble-gen-avatar.svg';
import { colourPalette } from 'styles/styles';

export const TopBarChatButtonStyle = {
  Container: styled.div`
    max-width: fit-content;
    margin-left: 8px;
    height: 32px;
  `,
  YabbleGenAvatar: styled(YabbleGenAvatarSvg)`
    width: 32px;
    height: 32px;
    cursor: pointer;
    & > rect {
      fill: ${colourPalette.neutral600};
      transition: all 0.3s ease-in-out;
    }
    &:hover {
      & > rect {
        fill: ${colourPalette.neutral900};
      }
    }
  `,
};
